import React from 'react'
//import numeral from 'numeral'
import { compose, withState, lifecycle, withHandlers } from 'recompose'
import { FormattedMessage } from 'react-intl'
import { FormattedHTMLMessage } from 'react-intl'

let seconds = null

let TimerEl = ({ elapsed, extendTime}) => (
  <div className='LotBlockTimer'>
    <span className='LotFinishesIn' style={{verticalAlign:'bottom', opacity: elapsed === 0 && 0}}>
      <FormattedMessage id='timer.auction_finish' /><br></br>
      {' '}
      <span className={elapsed>900? 'LotFinishesIn_black' : 'LotFinishesIn_red'}>
        {(elapsed>900) ?
        (<div>
          {Math.floor(elapsed/86400)} дн. {' '}
          {Math.floor(elapsed/3600)%24} ч. {' '}
          {Math.floor(elapsed/60)%60} мин. {' '} 
        </div>)
        : 
        (<div>
          {Math.floor(elapsed/60)%60} мин. {' '}
          {Math.floor(elapsed%60)} c. {' '} 
        </div>)
        
        }
        {/* {numeral(elapsed%60) !== 60 ? numeral(elapsed%60).format('00') : '00'} sec<br></br> */}
        {/* {Math.floor(elapsed/60)}:{numeral(elapsed%60) !== 60 ? numeral(elapsed%60).format('00') : '00'} */}
      </span>
    </span>

    {/*elapsed < 900 &&*/ extendTime && <div style={{width: '100%'}}><br></br><span className='LotFinishesIn' style={{color: '#ff5027', border: 'none', textAlign: 'left'}}><FormattedHTMLMessage id='lot.auctionExtends'/></span></div>}
  </div>
)

TimerEl = compose(
  lifecycle({
    componentDidMount () {
      this.props.updateTimer()
      seconds = null
    },
    componentWillUnmount () {
      clearInterval(this.timer)
    },
    componentWillReceiveProps (np) {
      if (np.elapsed === 0) {
        this.timer = setInterval(() => {
          this.props.updateTimer()
          if (this.props.elapsed <= 0) {
            clearInterval(this.timer);
            //скрываем кнопку Сделать ставку
            np.closeAlert();
          }
        }, 1000)
      }
    }
  })
)(TimerEl)

const Timer = ({ elapsed, setElapsed, time, lotClosed, data }) => {
  if(seconds === null) {
    seconds = time
    elapsed = 0
  }
  return (
    <span>
      {(elapsed >= 0) && <TimerEl updateTimer={setElapsed} elapsed={elapsed} extendTime={data.extendTime} closeAlert={lotClosed}/>}
      {(elapsed < 0) && (<span className='Text' style={{color:'#ff5027'}}><FormattedMessage id='timer.auction_completed' /></span>)}
    </span>
  )}

export default compose(
  withState('elapsed', 'setElapsed', null),
  withHandlers({
    setElapsed: ({ setElapsed, elapsed, time}) => () => {
      if((elapsed === null && elapsed !== seconds) || (seconds !== time)){//only for start или когда происходит продление аукциона
        seconds = time
        elapsed = seconds
        //seconds = 0
      }
      let value = elapsed - 1
      setElapsed(value)
    },
  })
)(Timer)



// WEBPACK FOOTER //
// ./src/components/Lot/Timer.jsx